import React, { useEffect, useState } from 'react';
import styles from '../Secure.module.scss';
import { GenericTab, Tabs } from '../components/Tabs';
import { useNavigate, useParams } from 'react-router-dom';
import { WallPage } from './components/Pages/WallPage';

const tabsConfiguation: Array<GenericTab> = [
   {
      id: 0,
      label: 'MY',
      href: 'my',
      element: <WallPage key="my" tab="my" />
   },
   {
      id: 1,
      label: 'FOLLOWED',
      href: 'followed',
      element: <WallPage key="followed" tab="followed" />
   },
   {
      id: 2,
      label: 'ALL',
      href: 'all',
      element: <WallPage key="all" tab="all" />
   }
];

export const Wall: React.FC = () => {
   const params = useParams();
   const [selectedTab, setSelectedTab] = useState<GenericTab | null | undefined>(() => {
      if (params && params.tab) {
         const selectedTab = tabsConfiguation.find((tab: GenericTab) => tab.href === params.tab);

         if (selectedTab) {
            return selectedTab;
         }
      }

      return tabsConfiguation[0];
   });

   const navigate = useNavigate();

   useEffect(() => {
      if (selectedTab) {
         navigate(`/wall/${selectedTab.href}`);
      }
   }, []);

   const handleRenderContent = () => {
      if (!selectedTab) {
         return null;
      }

      return selectedTab.element;
   };

   return (
      <div className={styles.matchesWrapper}>
         <Tabs tabs={tabsConfiguation} updateParentChange={setSelectedTab} pageHref="/wall" />
         {handleRenderContent()}
      </div>
   );
};
